import { atom } from 'recoil';

export const cashOutWallet = atom({
  key: 'cashOutWallet',
  default: undefined,
});
